<template>
  <!-- 编辑/新建属性弹窗 -->
  <el-dialog
    :title="titleDialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="600px"
    class="dialog"
    center
  >
    <div class="contents">
      <el-form
        label-width="150px"
        ref="refForm"
        :model="formData"
        :rules="formRules"
      >
        <el-form-item label="属性名称" prop="field_key">
          <el-input
            v-model="formData.field_key"
            :disabled="titleDialog == '添加属性' ? false : true"
            placeholder="请输入"
            clearable
            maxlength="10"
            @input="handleInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="属性值" prop="field_map">
          <!-- 拖拽区域 start -->
          <div class="tag-list" v-if="formData.field_map.length">
            <div
              class="tag"
              v-for="(child, index) of formData.field_map"
              :key="index"
            >
              <div class="name">
                <el-input
                  v-if="system_type == PROPERTY_TYPE_ENUM[0].value"
                  v-model="child.name"
                  placeholder=""
                  clearable
                  maxlength="10"
                ></el-input>

                <el-select
                  v-if="system_type == PROPERTY_TYPE_ENUM[1].value"
                  v-model="child.name"
                  clearable
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    :label="itenchild"
                    v-for="(itenchild, i) in options"
                    :value="itenchild"
                    :key="i"
                  ></el-option>
                </el-select>
              </div>
              <div class="icon-wrap" @click="onDelete(index)">
                <i class="icon el-icon-delete"></i>
              </div>
              <div class="icon-wrap">
                <i
                  class="icon el-icon-plus"
                  v-if="index === formData.field_map.length - 1"
                  @click="onCreate"
                ></i>
              </div>
              <div class="icon-wrap">
                <i class="icon el-icon-rank" @click="onRemove(index)"></i>
              </div>
            </div>
          </div>
          <!-- 拖拽区域 end -->

          <div v-else class="tag-add" @click="onCreate">
            <i class="el-icon-plus"></i>&nbsp;添加属性值
          </div>
        </el-form-item>

        <el-form-item label="是否必填" prop="is_must">
          <el-radio-group v-model="formData.is_must">
            <!--  编辑属性 包装方式 非果蔬不可编辑 必填 -->
            <el-radio
              :label="1"
              :disabled="
                titleDialog == '编辑属性' &&
                cidType == 2 &&
                formData.field_key == '包装方式'
                  ? true
                  : false
              "
              >是</el-radio
            >
            <el-radio
              :label="0"
              :disabled="
                titleDialog == '编辑属性' &&
                cidType == 2 &&
                formData.field_key == '包装方式'
                  ? true
                  : false
              "
              >否</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否显示/隐藏" prop="is_show">
          <el-switch
            class="switch"
            v-model="formData.is_show"
            :active-value="1"
            :inactive-value="0"
            :width="50"
          >
          </el-switch>
        </el-form-item>
        <div class="d-flex a-center">
          <el-form-item label="是否可编辑" prop="product_edit_type">
            <el-radio-group v-model="formData.product_edit_type">
              <el-radio :label="1">可编辑</el-radio>
              <el-radio :label="0">不可编辑</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="margin-bottom: 23px; margin-left: 20px">
            <el-tooltip
              class="item"
              effect="dark"
              content="控制对已发售的商品下架后，是否可编辑该属性的属性值"
              placement="top"
            >
              <i class="el-icon-question" style="cursor: pointer"></i>
            </el-tooltip>
          </div>
        </div>
        <el-form-item label="是否在分类页面显示" prop="is_searchable">
            <el-radio-group v-model="formData.is_searchable">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取消</el-button>
      <el-button type="primary" @click="onHandleSubmit" :loading="loadingSubmit"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import Sortable from "sortablejs";
import {
  postCategoriesCustomFieldSave,
  postCategoriesCustomPropertList,
} from "@/api/generalControl/key-attributes.js";
import { PROPERTY_TYPE_ENUM } from "@/views/general/utils/enum";

export default {
  name: "AddAttributeDialog",
  props: ["cidType"],
  data() {
    return {
      PROPERTY_TYPE_ENUM,
      dialogVisible: false,
      loadingSubmit: false,
      titleDialog: "",
      MAX_TAG_LENGTH: 20, // tag最多个数
      formData: {
        category_field_id: "",
        cid: "",

        field_key: "",
        field_map: [], // tag列表
        is_must: 1,
        product_edit_type: 0,
        is_searchable: 1,
        is_show: 1,
      }, // 表单数据
      formDataClone: {}, // 复制一份，用于初始化
      sortableObj: null, // 拖拽对象
      formRules: {
        field_key: [{ required: true, message: "请输入属性名称" }],
        field_map: [{ required: true, message: "请输入属性值" }],
        is_must: [{ required: true, message: "请选择是否必填" }],
        product_edit_type: [{ required: true, message: "请选择是否可编辑" }],
        is_show: [{ required: true, message: "请选择是否展示" }],
        is_searchable: [{ required: true, message: "请选择是否分类页展示" }],
      },
      options: [],
      system_type: "", // 0 文本框 1下拉框
    };
  },
  methods: {
    // 限制汉字、数字、【】、（），限制10个汉字
    handleInput(e) {
      // 过滤非法字符
      const validStr = e.replace(/[^\u4e00-\u9fa50-9【】（）]/g, "");

      // 限制字符数量
      if (validStr.length > 10) {
        this.formData.field_key = validStr.substring(0, 10);
      } else {
        this.formData.field_key = validStr;
      }
    },
    /**
     * 初始化
     */
    async onInitData(cid, data) {
      console.log(data, "data==");

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.refForm.clearValidate();
      });
      this.formDataClone = cloneDeep(this.formData);
      this.system_type = data && data.system_type ? data.system_type : 0; // 区分属性类型 默认文本框
      this.formData.cid = cid;
      if (data) {
        this.titleDialog = "编辑属性";
        // 编辑特殊属性 下拉框属性值
        if (data.system_type == this.PROPERTY_TYPE_ENUM[1].value) {
          this.postAjaxCategoriesCustomPropertList(data);
        }
        const {
          field_key,
          field_map,
          is_must,
          product_edit_type,
          is_searchable,
          is_show,
          id,
        } = data;
        let tmpFieldName = [];
        field_map.forEach((fItem) => {
          tmpFieldName.push({
            name: fItem,
          });
        });
        const tmpObj = {
          field_key,
          field_map: tmpFieldName,
          is_must,
          product_edit_type,
          is_searchable,
          is_show,
          category_field_id: id,
          cid: cid,
        };
        Object.keys(this.formData).forEach((_key) => {
          this.formData[_key] = tmpObj[_key];
        });
        console.log(this.formData, " this.formData==");
      } else {
        this.titleDialog = "添加属性";
      }
      if (!this.formData.field_map.length) {
        this.onCreate();
      }
      this.$nextTick(() => {
        this.initSortable();
      });
    },
    /**
     * 初始化拖拽
     */
    initSortable() {
      const dom = this.$el.querySelectorAll(".tag-list");
      this.sortableObj = null;
      dom.forEach((item) => {
        this.sortableObj = Sortable.create(item, {
          // 触发拖拽的class
          handle: ".el-icon-rank",
          animation: 150,
          onEnd: ({ newIndex, oldIndex }) => {
            // 得到最新的列表
            const list = cloneDeep(this.formData.field_map);
            const unit = list.splice(oldIndex, 1);
            list.splice(newIndex, 0, ...unit);
            this.formData.field_map = [];
            this.$nextTick(() => {
              this.formData.field_map = cloneDeep(list);
            });
            // console.log("🆒 initSortable data", newIndex, oldIndex, list);
          },
        });
      });
    },
    /**
     * 增加
     */
    onCreate() {
      const options = {
        name: "",
      };
      this.formData.field_map.push(options);
    },
    /**
     * 删除
     */
    onDelete(index) {
      this.formData.field_map.splice(index, 1);
    },
    /**
     * 移动
     */
    onRemove(index) {},
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.formData = {
        ...this.formDataClone,
      };
      this.dialogVisible = false;
    },
    // 下拉框属性
    async postAjaxCategoriesCustomPropertList(e) {
      try {
        const res = await postCategoriesCustomPropertList({
          id: e.id,
        });
        this.options = res.data.list || [];
        console.log(res, "res==");
      } catch (error) {
        console.log(error, "postCategoriesCustomPropertList");
      }
    },
    /**
     * 确认
     */
    onHandleSubmit() {
      this.ajaxPostUpdateCategoryTag();
    },
    /**
     * 提交
     */
    async ajaxPostUpdateCategoryTag() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formData));
          let tmpArr = []; // 为空数组
          let tmpArr1 = [];
          params.field_map.map((item) => {
            if (!item.name) {
              tmpArr.push(item.name);
            } else {
              tmpArr1.push(item.name);
            }
          });
          if (tmpArr.length > 0) {
            this.tool.message("请填写属性值！", "error");
            return;
          } else {
            params.field_map = tmpArr1;
          }
          this.loadingSubmit = true;
          try {
            await postCategoriesCustomFieldSave(params);
            this.$message.success("操作成功");
            this.$emit("on-change");
            this.onHandleClose();
          } catch (err) {
            console.log("ajax  postCategoriesCustomFieldSave err", err);
          } finally {
            this.loadingSubmit = false;
          }
        } else {
          console.log("error submit!!");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #13ae67;

.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
    .switch-wrap {
      display: flex;
      align-content: center;
      gap: 10px;
      .label {
        width: 100px;
        font-size: 14px;
        font-weight: 550;
      }
    }
    .tag-list {
      max-height: 400px;
      //  margin-top: 20px;
      overflow-y: auto;
      .tag {
        position: relative;
        display: flex;
        align-content: center;
        gap: 15px;
        padding-right: 15px;
        margin-bottom: 10px;
        .icon-wrap {
          width: 15px;
        }
        .name {
          flex: 1;
        }
        .icon {
          position: relative;
          top: 10px;
          cursor: pointer;
        }
      }
    }
    .tag-add {
      display: inline-block;
      // margin-top: 50px;
      color: $color;
      cursor: pointer;
    }
  }
}
</style>
